import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../Axios/index";


export const leadCapture = createAsyncThunk("lead/captureLead", async (obj, { rejectWithValue }) => {
  try {
    const response = await axios.post(`lead/captureLead` , obj);
    return response.data.data;
  } catch (err) {
    return rejectWithValue({status : false , error: err.response?.error || "Email already exists"});
  }
});

export const sendContactUs = createAsyncThunk("lead/sendContactUs", async (obj, { rejectWithValue }) => {
  try {
    const response = await axios.post(`lead/sendContactUs` , obj);
    return response.data.data;
  } catch (err) {
    return rejectWithValue(err.response.data);
  }
});

export const getUser = createAsyncThunk("lead/getUser", async (_,{ rejectWithValue }) => {
  try {
    const response = await axios.post(`lead/getUser`);
    return response.data.results;
  } catch (err) {
    return rejectWithValue(err.response.data);
  }
});

const lead = createSlice({
  name: "user",
  initialState: {
    lead: null,
    status: "idle",
    error: null,
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(leadCapture.pending, (state)=>{
      state.loading = true;
    })
    .addCase(leadCapture.fulfilled , (state , action)=>{
      state.loading = false;
      state.lead = action.payload
      action?.payload?.token && localStorage.setItem("token", action.payload.token)
    }).addCase(leadCapture.rejected , (state , action)=>{
      state.loading = false;
      state.error = action.payload
    })

    builder.addCase(getUser.pending, (state)=>{
      state.loading = true;
    })
    .addCase(getUser.fulfilled , (state , action)=>{
      state.loading = false;
      console.log("lead in redux" , action.payload)
      state.lead = action.payload
    }).addCase(getUser.rejected , (state , action)=>{
      state.loading = false;
      state.error = action.payload
    })

    builder.addCase(sendContactUs.pending, (state)=>{
      state.loading = true;
    })
    .addCase(sendContactUs.fulfilled , (state , action)=>{
      state.loading = false;
    }).addCase(sendContactUs.rejected , (state , action)=>{
      state.loading = false;
      state.error = action.payload
    })

    
    
  }
});

export default lead.reducer;
